<template>
  <div>
  <user-menu />
  <div class="wrapper">
    <researcher-sidebar-menu />
    <div class="content-wrapper">
      <div><h3 class="d-inline heading">Home</h3></div>
      <div class="hs-dashboard"></div>
    <div class="home-main-wrapper center">
      <div class="col-12 col-sm-12 col-md-6 col-lg-4 float-left">
        <div class="jumbotron">
          <div class="text-align-center">
            <router-link to="/account-lookup">
              <div class="fa fa-user-o"></div>
              <div><b>Account Lookup</b></div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-4 float-left">
        <div class="jumbotron">
          <div class="text-align-center">
            <router-link to="/myprofile">
              <div class="fa fa-user-circle-o"></div>
              <div><b>My Profile</b></div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-4 float-left">
        <div class="jumbotron">
          <div class="text-align-center">
            <router-link to="/report-dashboard">
              <div class="fa fa-line-chart"></div>
              <div><b>Reports</b></div>
            </router-link>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
  </div>
  </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import router from '../../router/index.js';
import store from '../../store/store.js';
import ResearcherSidebarMenu from '../shared/researcher_sidebar_menu.vue';

export default {
  components: {
    UserMenu,
    ResearcherSidebarMenu
  },
  beforeCreate: function() {
    this.$store.dispatch('active_tab', '');
  },
  created() {
    if((this.$store.state.switch_admin_username)) {
      if(this.$store.state.switch_admin_account_flag == 1) {
        router.push('/school-admin-dashboard');
      }
      else {
        router.push('/company-admin-dashboard');
      }
    }

  }
}
</script>

<style scoped>
  .jumbotron {
    background-color: #DDD;
    padding: 3rem 2rem;
  }
  .jumbotron a {
    color: #000;
  }
  .jumbotron .fa {
    font-size: 25px;
    padding-bottom: 5px;
  }
  .dashboard-link a {
    color: #000;
    font-size: 22px;
    line-height: 50px;
  }
  .dashboard-link a:hover {
    color: #000;
    text-decoration: none;
  }
  .home-main-wrapper {
	  background: none;
    padding: 30px 0px 0px 0px;
  }
  @media(min-width:1204px) {
	.home-main-wrapper {
	  width: 70%;
	}
  }
  @media(max-width:1200px) {
	.home-main-wrapper {
	  width: 70%;
	}
  }
  @media(max-width:768px) {
	.home-main-wrapper {
	  width: 85%;
	}
  }
  @media(max-width:560px) {
	.home-main-wrapper {
	  width: 100%;
	}
  }
  .hs-dashboard {
    border-bottom: 2px solid #00ACEE !important;
    margin: 10px 10px 0px 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/researcher/researcher_dashboard.vue